import documentSelectionData from "../../../Utils/document-selection.json";

interface DocumentEntry {
  config: { nfc_processable: boolean };
  document_type: string;
  issuing_country: string;
}

interface SelectOption {
  value: string;
  labelKey: string;
}

const DOC_TYPE_ORDER = [
  "passport",
  "national_identity_card",
  "residence_permit",
];

const LABEL_KEYS = {
  passport: "passport",
  national_identity_card: "national_identity_card",
  residence_permit: "residence_permit",
};

const COUNTRY_LABEL_MAP = {
  ESP: "spain",
  FRA: "france",
  ITA: "italy",
  DEU: "germany",
  PRT: "portugal",
  GBR: "unitedKingdom",
  USA: "unitedStates",
  ARG: "argentina",
  MEX: "mexico",
  COL: "colombia",
  PER: "peru",
  CHL: "chile",
  ECU: "ecuador",
  VEN: "venezuela",
  MAR: "morocco",
  ROU: "romania",
  BGR: "bulgaria",
  UKR: "ukraine",
  CHN: "china",
  IND: "india",
};

const COUNTRY_NAME_MAP = {
  AFG: "Afghanistan",
  AGO: "Angola",
  AIA: "Anguilla",
  ALB: "Albania",
  AND: "Andorra",
  ARE: "United Arab Emirates",
  ARG: "Argentina",
  ARM: "Armenia",
  ATG: "Antigua and Barbuda",
  AUS: "Australia",
  AUT: "Austria",
  AZE: "Azerbaijan",
  BDI: "Burundi",
  BEL: "Belgium",
  BEN: "Benin",
  BFA: "Burkina Faso",
  BGD: "Bangladesh",
  BGR: "Bulgaria",
  BHR: "Bahrain",
  BHS: "Bahamas",
  BIH: "Bosnia and Herzegovina",
  BLR: "Belarus",
  BLZ: "Belize",
  BMU: "Bermuda",
  BOL: "Bolivia",
  BRA: "Brazil",
  BRB: "Barbados",
  BRN: "Brunei",
  BTN: "Bhutan",
  BWA: "Botswana",
  CAF: "Central African Republic",
  CAN: "Canada",
  CHE: "Switzerland",
  CHL: "Chile",
  CHN: "China",
  CIV: "Côte d'Ivoire",
  CMR: "Cameroon",
  COD: "DR Congo",
  COG: "Republic of the Congo",
  COL: "Colombia",
  COM: "Comoros",
  CPV: "Cape Verde",
  CRI: "Costa Rica",
  CUB: "Cuba",
  CYM: "Cayman Islands",
  CYP: "Cyprus",
  CZE: "Czech Republic",
  DEU: "Germany",
  DJI: "Djibouti",
  DMA: "Dominica",
  DNK: "Denmark",
  DOM: "Dominican Republic",
  DZA: "Algeria",
  ECU: "Ecuador",
  EGY: "Egypt",
  ERI: "Eritrea",
  EST: "Estonia",
  ETH: "Ethiopia",
  FIN: "Finland",
  FJI: "Fiji",
  FRA: "France",
  FRO: "Faroe Islands",
  FSM: "Micronesia",
  GAB: "Gabon",
  GBR: "United Kingdom",
  GEO: "Georgia",
  GGY: "Guernsey",
  GHA: "Ghana",
  GIB: "Gibraltar",
  GIN: "Guinea",
  GMB: "Gambia",
  GNB: "Guinea-Bissau",
  GNQ: "Equatorial Guinea",
  GRC: "Greece",
  GRD: "Grenada",
  GRL: "Greenland",
  GTM: "Guatemala",
  GUY: "Guyana",
  HND: "Honduras",
  HRV: "Croatia",
  HTI: "Haiti",
  HUN: "Hungary",
  IDN: "Indonesia",
  IMN: "Isle of Man",
  IND: "India",
  IRL: "Ireland",
  IRN: "Iran",
  IRQ: "Iraq",
  ISL: "Iceland",
  ISR: "Israel",
  ITA: "Italy",
  JAM: "Jamaica",
  JEY: "Jersey",
  JOR: "Jordan",
  JPN: "Japan",
  KAZ: "Kazakhstan",
  KEN: "Kenya",
  KGZ: "Kyrgyzstan",
  KHM: "Cambodia",
  KIR: "Kiribati",
  KNA: "Saint Kitts and Nevis",
  KOR: "South Korea",
  KWT: "Kuwait",
  LAO: "Laos",
  LBN: "Lebanon",
  LBR: "Liberia",
  LBY: "Libya",
  LCA: "Saint Lucia",
  LIE: "Liechtenstein",
  LKA: "Sri Lanka",
  LSO: "Lesotho",
  LTU: "Lithuania",
  LUX: "Luxembourg",
  LVA: "Latvia",
  MAR: "Morocco",
  MCO: "Monaco",
  MDA: "Moldova",
  MDG: "Madagascar",
  MDV: "Maldives",
  MEX: "Mexico",
  MHL: "Marshall Islands",
  MKD: "North Macedonia",
  MLI: "Mali",
  MLT: "Malta",
  MMR: "Myanmar",
  MNE: "Montenegro",
  MNG: "Mongolia",
  MOZ: "Mozambique",
  MRT: "Mauritania",
  MSR: "Montserrat",
  MUS: "Mauritius",
  MWI: "Malawi",
  MYS: "Malaysia",
  NAM: "Namibia",
  NER: "Niger",
  NGA: "Nigeria",
  NIC: "Nicaragua",
  NLD: "Netherlands",
  NOR: "Norway",
  NPL: "Nepal",
  NRU: "Nauru",
  NZL: "New Zealand",
  OMN: "Oman",
  PAK: "Pakistan",
  PAN: "Panama",
  PER: "Peru",
  PHL: "Philippines",
  PLW: "Palau",
  PNG: "Papua New Guinea",
  POL: "Poland",
  PRK: "North Korea",
  PRT: "Portugal",
  PRY: "Paraguay",
  PSE: "Palestine",
  QAT: "Qatar",
  RKS: "Kosovo",
  ROU: "Romania",
  RUS: "Russia",
  RWA: "Rwanda",
  SAU: "Saudi Arabia",
  SDN: "Sudan",
  SEN: "Senegal",
  SGP: "Singapore",
  SHN: "Saint Helena",
  SLB: "Solomon Islands",
  SLE: "Sierra Leone",
  SLV: "El Salvador",
  SMR: "San Marino",
  SOM: "Somalia",
  SRB: "Serbia",
  SSD: "South Sudan",
  STP: "São Tomé and Príncipe",
  SUR: "Suriname",
  SVK: "Slovakia",
  SVN: "Slovenia",
  SWE: "Sweden",
  SWZ: "Eswatini",
  SYC: "Seychelles",
  SYR: "Syria",
  TCA: "Turks and Caicos Islands",
  TCD: "Chad",
  TGO: "Togo",
  THA: "Thailand",
  TJK: "Tajikistan",
  TKM: "Turkmenistan",
  TLS: "Timor-Leste",
  TON: "Tonga",
  TTO: "Trinidad and Tobago",
  TUN: "Tunisia",
  TUR: "Turkey",
  TUV: "Tuvalu",
  TWN: "Taiwan",
  TZA: "Tanzania",
  UGA: "Uganda",
  UKR: "Ukraine",
  URY: "Uruguay",
  USA: "United States",
  UZB: "Uzbekistan",
  VAT: "Vatican City",
  VCT: "Saint Vincent and the Grenadines",
  VEN: "Venezuela",
  VGB: "British Virgin Islands",
  VNM: "Vietnam",
  VUT: "Vanuatu",
  WSM: "Samoa",
  YEM: "Yemen",
  ZAF: "South Africa",
  ZMB: "Zambia",
  ZWE: "Zimbabwe",
};

export function getCountryLabelKey(isoCode: string): string {
  return COUNTRY_LABEL_MAP[isoCode] || COUNTRY_NAME_MAP[isoCode] || isoCode;
}

const allDocTypes: SelectOption[] = Array.from(
  new Set(documentSelectionData.documents.map((d) => d.document_type))
)
  .sort((a, b) => {
    const ia = DOC_TYPE_ORDER.indexOf(a);
    const ib = DOC_TYPE_ORDER.indexOf(b);
    return (ia === -1 ? 999 : ia) - (ib === -1 ? 999 : ib);
  })
  .map((type) => ({ value: type, labelKey: LABEL_KEYS[type] || type }));

const allCountries: SelectOption[] = Array.from(
  new Set(documentSelectionData.documents.map((d) => d.issuing_country))
).map((code) => ({
  value: code,
  labelKey: getCountryLabelKey(code),
}));

const countryDocMap: Record<string, Set<string>> = {};
const docCountryMap: Record<string, Set<string>> = {};

documentSelectionData.documents.forEach(
  ({ document_type, issuing_country }) => {
    if (!countryDocMap[issuing_country]) {
      countryDocMap[issuing_country] = new Set();
    }
    countryDocMap[issuing_country].add(document_type);

    if (!docCountryMap[document_type]) {
      docCountryMap[document_type] = new Set();
    }
    docCountryMap[document_type].add(issuing_country);
  }
);

export const DOC_TYPES = allDocTypes;
export const COUNTRIES = allCountries;

export function getCountriesForDocType(docType: string) {
  if (!docType || !docCountryMap[docType]) return allCountries;
  return Array.from(docCountryMap[docType]).map((code) => ({
    value: code,
    labelKey: getCountryLabelKey(code),
  }));
}

export function getDocumentsForCountry(countryCode: string): SelectOption[] {
  if (!countryCode || !countryDocMap[countryCode]) return allDocTypes;
  return Array.from(countryDocMap[countryCode])
    .sort((a, b) => {
      const ia = DOC_TYPE_ORDER.indexOf(a);
      const ib = DOC_TYPE_ORDER.indexOf(b);
      return (ia === -1 ? 999 : ia) - (ib === -1 ? 999 : ib);
    })
    .map((type) => ({ value: type, labelKey: LABEL_KEYS[type] || type }));
}
